import { styled } from "../../theme";
export const Label = styled.label `
  display: block;
  margin-bottom: 5px;
`;
